/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Table_TokensInputs */

const en_settings_table_tokens = /** @type {(inputs: Settings_Table_TokensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tokens`)
};

const de_settings_table_tokens = /** @type {(inputs: Settings_Table_TokensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tokens`)
};

const fr_settings_table_tokens = /** @type {(inputs: Settings_Table_TokensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetons`)
};

const es_settings_table_tokens = /** @type {(inputs: Settings_Table_TokensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tokens`)
};

const it_settings_table_tokens = /** @type {(inputs: Settings_Table_TokensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token`)
};

const nl_settings_table_tokens = /** @type {(inputs: Settings_Table_TokensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tokens`)
};

const pl_settings_table_tokens = /** @type {(inputs: Settings_Table_TokensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tokeny`)
};

const fi_settings_table_tokens = /** @type {(inputs: Settings_Table_TokensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merkit`)
};

const da_settings_table_tokens = /** @type {(inputs: Settings_Table_TokensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tokens`)
};

const sv_settings_table_tokens = /** @type {(inputs: Settings_Table_TokensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token`)
};

/**
* | output |
* | --- |
* | "Tokens" |
*
* @param {Settings_Table_TokensInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_table_tokens = /** @type {((inputs?: Settings_Table_TokensInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Table_TokensInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_table_tokens(inputs)
	if (locale === "fr") return fr_settings_table_tokens(inputs)
	if (locale === "es") return es_settings_table_tokens(inputs)
	if (locale === "it") return it_settings_table_tokens(inputs)
	if (locale === "nl") return nl_settings_table_tokens(inputs)
	if (locale === "pl") return pl_settings_table_tokens(inputs)
	if (locale === "fi") return fi_settings_table_tokens(inputs)
	if (locale === "da") return da_settings_table_tokens(inputs)
	if (locale === "sv") return sv_settings_table_tokens(inputs)
	return en_settings_table_tokens(inputs)
});